enum CustomHeaders {
    PRODUCT_ID = 'X-Product-Id',
    AUTHORIZATION = 'Authorization'
}

export default CustomHeaders;
